import CloseIcon from "@mui/icons-material/Close";
import {
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { useIsMobile } from "hooks/useIsMobile";
import React from "react";

interface Props {
  open: boolean;
  doClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  width: number;
}

export const DrawerLayout = ({
  open,
  doClose,
  title,
  children,
  width,
}: React.PropsWithChildren<Props>) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={(event: Event) => {
        event.stopPropagation();
        event.preventDefault();
        doClose();
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "transparent",
            top: isMobile ? "var(--app-bar-height, 0px)" : 0,
          },
        },
        paper: {
          sx: isMobile
            ? {
                top: "var(--app-bar-height, 0px)",
                height: "calc(100vh - var(--app-bar-height, 0px))",
                width: "100%",
              }
            : {},
        },
      }}
    >
      {!isMobile && <Toolbar />}
      <Stack
        sx={{
          width: isMobile ? "100%" : `${width}px`,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {!isMobile && (
          <Stack
            spacing={1}
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              borderBottomWidth: "1px",
              borderBottomStyle: "solid",
              borderBottomColor: theme.palette.common.black,
              paddingX: 3,
              paddingY: 2,
            }}
          >
            <IconButton
              onClick={() => {
                doClose();
              }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h2">{title}</Typography>
          </Stack>
        )}
        <Stack
          sx={{
            paddingX: isMobile ? 2 : 3,
            marginY: isMobile ? 0 : 2,
            flex: 1,
            overflowY: "auto",
          }}
        >
          {children}
        </Stack>
      </Stack>
    </Drawer>
  );
};
